<template>
  <div class="context__form-container">
    <!-- No @input needed: this child form self-registers with the parent
    form (provide/inject in the `form` mixin), so its `source_field_id`
    value and validity are picked up automatically by getFormValues()/
    isFormValid()'s child-form tree-walk. -->
    <SourceFieldSelectSubForm
      :fields="allFieldsInTable"
      :allowed-field-types="allowedSourceFieldTypes"
    />
  </div>
</template>

<script>
import form from '@baserow/modules/core/mixins/form'
import fieldSubForm from '@baserow/modules/database/mixins/fieldSubForm'
import SourceFieldSelectSubForm from '@baserow/modules/database/components/field/SourceFieldSelectSubForm'
import { SOURCE_FIELD_REFERENCE_ALLOWED_TYPES } from '@baserow/modules/database/utils/sourceFieldReferenceFieldTypes'

export default {
  name: 'FieldQRCodeSubForm',
  components: { SourceFieldSelectSubForm },
  mixins: [form, fieldSubForm],
  data() {
    return {
      // QR Code has no field-level config of its own (unlike Barcode's
      // `barcode_format`), so this form only wraps the source field picker.
      allowedValues: [],
      values: {},
      allowedSourceFieldTypes: SOURCE_FIELD_REFERENCE_ALLOWED_TYPES,
    }
  },
}
</script>
